<template>
    <v-container>
        <v-card class="dt-border pad-10" flat>
            <v-container>
                <v-row class="pa-5 mb-5">
                    <div>
                        <h2>Application Manager</h2>
                        <p>General users application controller </p>
                    </div>
                </v-row>
                <dtunes-loader :loading="loading"></dtunes-loader>
                <settings-table v-if="!loading" :settings="settings"/>
            </v-container>
        </v-card>
    </v-container>
</template>

<script>
// =========== IMPORT COMPONENT =========

import DtunesLoader from "@/components/dtunes-loader.vue"
import SettingsTable from "../component/settings-table.vue"
// =========== IMPORT SERVICES ===========
import {AppService, CryptoService} from '@/services';

export default {
    data:() => ({
        loading:false,
        dialog:true,
        active:[],
        updating: [],
        settings :[]
    }),
    components:{
        DtunesLoader,
        SettingsTable
    },
    mounted(){
        this.getSettings()
    },
    methods:{
        async getSettings(){
            try {
                this.loading = true;
                const data = await AppService.getSettings();
                const data2 = await CryptoService.retrieveSetting();
             
                for( let i = 0; i < data.length; i++){
                    data[i]['editable'] = false
                }
                const automatic ={created: data2.created,
                     updated: data2.updated, deleted: data2.deleted,
                    key: 'Automate Coin Trade Limit', id: data.id, value: data2.maxAutomatic,
                    editable: false};
                  
                
                this.settings = data;
                this.settings.push(automatic);
                this.loading = false;
            } catch (error) {
                this.loading = false
            }
        },

    }
}
</script>

<style lang="scss">
</style>